import { Box, Typography, useTheme } from '@mui/material';
import UseCurrency from '@shared/hooks/UseCurrency';

const RenderButton = ({ label, data, icons = [], selectedOption }) => {
  const { currency } = UseCurrency();

  const theme = useTheme();

  const price = data?.difference?.total ?? 0;

  if (!data) return null;

  return (
    <Box
      onClick={() => selectedOption(data)}
      id={`${label}-main-box-render-button`}
      sx={{
        width: { xs: '135px', md: '200px' },
        height: { xs: 90, md: 110, lg: 130 },
        borderRadius: 2,
        border: '1px solid #ddd',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: { xs: 1, sm: 1.5 },
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 3,
        },
      }}
    >
      {/* ICONOS */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'center',
          gap: 0.5,
          height: { xs: 36, sm: 40, md: 46 },
        }}
      >
        {icons.map((icon, idx) => {
          const Icon = icon.Component;

          return (
            <Box
              key={`${label}-${idx}`}
              sx={{
                width: icon.size,
                height: icon.size,
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'center',
                flexShrink: 0,

                '& svg': {
                  height: '100%',
                  width: 'auto',
                  display: 'block',
                },
              }}
            >
              <Icon color={theme.tertiary} />
            </Box>
          );
        })}
      </Box>

      {/* Título */}
      <Typography
        sx={{
          fontWeight: 700,
          textAlign: 'center',
          color: 'text.primary',
          fontSize: { xs: 13, sm: 14, md: 16, lg: 18 },
        }}
      >
        {label}
      </Typography>

      {/* Precio */}
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: { xs: 12, sm: 13, md: 15, lg: 16 },
          color: 'text.secondary',
        }}
      >
        {+price === 0 ? 'Sin costo' : `${currency(price)}`}
      </Typography>
    </Box>
  );
};

export default RenderButton;
